<template>
  <div id="modal-wrapper" :class="fullscreen ? 'modal-full' : false" v-if="content">
    <div id="modal">
      <div id="modal-header" class="expanded row align-middle">
        <div class="columns" v-html="title"></div>
        <div class="columns shrink">
          <a class="clear button" @click.prevent="toggleSize"><i :class="fullscreen ? 'icon icon-shrink2' : 'icon icon-enlarge2'"></i></a>
          <a class="clear button" @click.prevent="close"><i class="icon icon-cross"></i></a>
        </div>
      </div>
      <div id="modal-content" v-html="content"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Modal',
    props: {
      title: {
        type: String,
        required: false
      },
      content: {
        type: String,
        required: true
      },
    },
    data() {
      return {
        fullscreen: false
      }
    },
    methods: {
      close() {
        this.$store.commit('modal/emptyModal', null, {root: true});
        this.fullscreen = false;
      },
      toggleSize() {
        this.fullscreen = !this.fullscreen
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Modal.vue